<div class="container-fluid">
    <div class="row">
        <div class="col-12 col-md-3 col-xl-2 p-0">
            <div class="it25-sidebar-wrapper">
                <nav class="it25-sidebar-links collapse pr-0" id="it25-main-nav">
                    <div class="sidebar-wrapper">
                        <div class="sidebar-linklist-wrapper">
                            <div class="link-list-wrapper">
                                <ul class="link-list">
                                    <li><a class="list-item" [routerLink]="['/cms', 'contatti']" routerLinkActive="active"><span>Contatti</span></a></li>
                                    <li><a class="list-item" [routerLink]="['/cms', 'accessibilita']" routerLinkActive="active"><span>Accessibilità</span></a></li>
                                    </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
        <main class="col-12 col-md-9 col-xl-8 py-md-3 px-md-3">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>